import axios from 'axios';
import { useMutation } from 'react-query';
import { AuthContext } from '../../Context/AuthContext';
import { useContext } from 'react';


const deleteOtherDocs = async (token, otherDocuments) => {
  const response = await axios.delete(`${process.env.REACT_APP_SERVER_URL}/charterer/profile/delete/otherDocuments`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(otherDocuments)
  });
  return response.data;
};



export const useDeleteOtherDocs = () => {
  const { token } = useContext(AuthContext); 

  return useMutation((otherDocuments) => deleteOtherDocs(token, otherDocuments));
};
